import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import {
    loadCourseTemplateHealthDetails,
    loadWellbeingDetails
} from '../../../store/directusService';
import { formatDate } from '../../../utils/dateFunctions';
import AccordionHeader from '../../ui/accordion/AccordionHeader';
import AccordionIcon from '../../ui/accordion/AccordionIcon';

import ParticipantSection from './ParticipantSection';

import app from '../../../app.module.css';
import local from './moduleAttendanceDetails.module.css';

const ModuleAttendanceDetails = () => {
    const dispatch = useDispatch();
    const state = useLocation().state || {};

    // LOCAL STATE
    const [participants, setParticipants] = useState([]);
    const [healthTypes, setHealthTypes] = useState([]);
    const [expanded, setExpanded] = useState('');

    // STORE STATE
    const participantsSearch = useSelector(
        (state) => state.entities.participantService.participantsSearch
    );
    const courseTemplateHealthDetails = useSelector(
        (state) => state.entities.directusService.courseTemplateHealthDetails
    );
    const currentTemplate = useSelector((state) => state.entities.courseService.currentTemplate);

    // USEEFFECTS
    useEffect(() => {
        if (!courseTemplateHealthDetails?.length) dispatch(loadCourseTemplateHealthDetails());
        dispatch(loadWellbeingDetails());
    }, []);

    useEffect(() => {
        if ('participantIds' in state && participantsSearch?.length) {
            setParticipants(
                state.participantIds
                    .map((el) => participantsSearch.find((entry) => entry.id === el))
                    .filter((el) => el)
            );
        }
    }, [state?.participantIds, participantsSearch]);

    useEffect(() => {
        if (!currentTemplate?.healthInformationIds || !courseTemplateHealthDetails?.length) return;
        const types = currentTemplate.healthInformationIds
            .map((el) =>
                courseTemplateHealthDetails.find((entry) => entry.id === el)?.name?.toLowerCase()
            )
            .filter((el) => el);
        setHealthTypes(types);
    }, [courseTemplateHealthDetails, currentTemplate.healthInformationIds]);

    // EVENT HANDLERS
    const onAccordionChange = (panel) => setExpanded(expanded === panel ? '' : panel);

    // RENDER
    return (
        <div className={app.pageContainer}>
            <h1 className={app.mainHeading}>
                Course Module Attendance Details - {state?.module?.title || ''} {' - '}{' '}
                {formatDate(state?.module?.date) || ''} - {state?.module?.startTime || ''}
            </h1>
            <div>
                {participants?.length > 0 &&
                    participants.map((el) => (
                        <div key={el.id}>
                            <Accordion
                                expanded={expanded === el.id}
                                onChange={() => onAccordionChange(el.id)}
                                className={app.accordionDivider}
                                data-testid="participant-module-detail-accordions"
                                slotProps={{ transition: { mountOnEnter: true } }}>
                                <AccordionSummary
                                    expandIcon={<AccordionIcon />}
                                    aria-controls={`panel1a-content`}
                                    id={`panel1a-header`}>
                                    <AccordionHeader>
                                        <div className={local.accordionTitle}>
                                            <span>{el.ptCode} - </span>
                                            <span>{el.firstName || ''}</span>
                                            <span>{el.lastName || ''}</span>
                                        </div>
                                    </AccordionHeader>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {expanded === el.id && (
                                        <ParticipantSection
                                            participant={el}
                                            healthTypes={healthTypes}
                                            moduleId={state?.module?.id}
                                        />
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default ModuleAttendanceDetails;
